import { createAction } from '@reduxjs/toolkit';
import { alertActions } from '_actions';
import { messageCenterService } from '_services';
import { ActionNames, Errors } from '_constants'

export const pnDueActions = {
    load: () => dispatch => {
        dispatch(pnDueActions.loadRequest());
        messageCenterService.loadPNDue()
            .then(
                messages => {
                    dispatch(pnDueActions.loadSuccess(messages));
                },
                error => {
                    dispatch(pnDueActions.loadFailure(error));
                    dispatch(alertActions.error(Errors.PN_DUE_LOAD_FAILURE));
                }
            );
    },
    loadRequest: createAction(ActionNames.PN_DUE_LOAD_REQUEST),
    loadSuccess: createAction(ActionNames.PN_DUE_LOAD_SUCCESS),
    loadFailure: createAction(ActionNames.PN_DUE_LOAD_FAILURE),

    setSelectedMessage: createAction(ActionNames.PN_DUE_SET_SELECTED_MESSAGE),

    changeSelection: (epno) => (dispatch, getState) => {
        dispatch(pnDueActions.setSelectedMessage({ epno }));

        if (getState().entities.pnDueDetails.epno !== epno) {
            dispatch(pnDueActions.loadDetailsRequest({ epno }));

            messageCenterService.loadPNDueDetails(epno)
                .then(
                    details => { dispatch(pnDueActions.loadDetailsSuccess({ epno, details })) }
                    ,
                    error => {
                        dispatch(pnDueActions.loadDetailsFailure({ epno, error }));
                        dispatch(alertActions.error(Errors.PN_DUE_DETAILS_LOAD_FAILURE));
                    }
                );
        }


        if (!getState().entities.pnDue[epno].isRead) {
            dispatch(pnDueActions.markReadRequest({ epno }));

            let pndate = getState().entities.pnDue[epno].pnDate;
            let ispndue = getState().entities.pnDue[epno].isPNDue;
            let ispocdue = getState().entities.pnDue[epno].isPOCDue;

            messageCenterService.markReadPNDCDue(epno, pndate, ispndue, ispocdue, undefined)
                .then(
                    () => { dispatch(pnDueActions.markReadSuccess(epno)) }
                    ,
                    error => {
                        dispatch(pnDueActions.markReadFailure({ epno, error }));
                        dispatch(alertActions.error(Errors.PN_DUE_MARK_READ_FAILURE));
                    }
                );
        }
    },
    markReadRequest: createAction(ActionNames.PN_DUE_MARK_READ_REQUEST),
    markReadSuccess: createAction(ActionNames.PN_DUE_MARK_READ_SUCCESS),
    markReadFailure: createAction(ActionNames.PN_DUE_MARK_READ_FAILURE),

    loadDetailsRequest: createAction(ActionNames.PN_DUE_LOAD_DETAILS_REQUEST),
    loadDetailsSuccess: createAction(ActionNames.PN_DUE_LOAD_DETAILS_SUCCESS),
    loadDetailsFailure: createAction(ActionNames.PN_DUE_LOAD_DETAILS_FAILURE),

    clearSelection: createAction(ActionNames.PN_DUE_CLEAR_SELECTION),

}
